import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private data: any = {};

  constructor() { }

  public setData(key: string, data: any): void {
    // console.log('CacheService: setData - key: ', key, ' , data: ', data);
    this.data[key] = data;
  }

  public getData(key: string): any {
    // console.log('CacheService: getData - key: ', key, ' return val:', this.data[key]);
    return this.data[key];
  }

  public getDataOnce(key: string): any {
    // console.log('CacheService: getData - key: ', key, ' return val:', this.data[key]);
    const result = this.data[key];
    this.data[key] = null;
    return result;
  }

  public clearCache(): void {
    this.data = {};
  }
}
